// extracted by css-extract-rspack-plugin
export default {"cls1":"Unibrow-cls1__Yl","cls2":"Unibrow-cls2_4vK Unibrow-cls1__Yl"};